<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div
          class="fuel_consumption_row_right_section mr-3 pump__bg"
          style="border-radius: 12px; flex: 0 0 72%"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(41, 39, 39 , 0.92), rgb(41, 39, 39, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div
            class="row align-items-center justify-content-center"
            style="height: 100%"
          >
            <div
              class="col-md-12"
              style="display: flex; justify-content: center"
            >
              <h4 class="text-center text-white">
                {{ $t("text.omit.mapRolesFor") }}
                <b>{{ categoryName }}</b>
              </h4>
            </div>
          </div>
          <div class="transaction_period_text text-center mt-5"></div>
        </div>
      </div>

      <div class="new_row_section pb-4 mt-3">
        <div class="card border-0 px-4">
          <div class="row mt-3">
            <div class="col-md-7">
              <div class="mt-4">
                <label>{{ $t("text.iUsers.roles") }}</label>
                <div class="price_change_input_wrapper">
                  <div @click="toggleBranchListDropdown" style="padding: 5px">
                    <vue-tags-input
                      v-model="tag"
                      :tags="tags"
                      @tags-changed="(newTags) => (tags = newTags)"
                    />
                  </div>

                  <div class="">
                    <div class="search__wrapper">
                      <div class="row align-items-center">
                        <div class="col-md-10">
                          <input
                            type="search"
                            :placeholder="$t('text.omit.searchRole')"
                            v-model="searchInp"
                          />
                        </div>
                        <div class="col-md-2">
                          <i
                            class="fa fa-search"
                            aria-hidden="true"
                            style="color: #b6b6b6"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3" style="width: 100%; margin: 0 auto">
                      <div class="col-md-4">
                        <div classs="">
                          <b-form-checkbox
                            id="selectAll"
                            v-model="selectAll"
                            class="sec_text_color"
                          >
                            {{ $t("text.omit.selectRoles") }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row justify-content-center mt-3"
                      style="width: 100%; margin: 0 auto"
                    >
                      <div class="col-md-4">
                        <div class="">
                          <b-form-group
                            label=""
                            v-on:click.native="toggleChckBox($event)"
                          >
                            <b-form-checkbox-group
                              v-model="selected"
                              :options="filteredList"
                              name="flavour-2a"
                              stacked
                            >
                            </b-form-checkbox-group>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          label=""
                          v-on:click.native="toggleChckBox($event)"
                        >
                          <b-form-checkbox-group
                            v-model="selected"
                            :options="filteredList2"
                            name="flavour-2a"
                            stacked
                          >
                          </b-form-checkbox-group>
                        </b-form-group>
                      </div>
                      <div class="col-md-4">
                        <b-form-group
                          label=""
                          v-on:click.native="toggleChckBox($event)"
                        >
                          <b-form-checkbox-group
                            v-model="selected"
                            :options="filteredList3"
                            name="flavour-2a"
                            stacked
                          >
                          </b-form-checkbox-group>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5 d-flex justify-content-center">
                <button
                  class="save__btn record_expense_btn mr-2 w-50 btn_primary_color"
                  @click="mapCategoryRole()"
                  :disabled="isButtonDisabled ? true : null"
                  :style="[
                    isButtonDisabled
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' },
                  ]"
                >
                  {{ $t("text.omit.addMappedRoles") }}
                  <span>
                    <img
                      src="@/assets/img/git_loader.gif"
                      style="display: none"
                      width="25px"
                      class="loader ml-2"
                    />
                  </span>
                </button>
              </div>
            </div>
            <div class="col-md-3 ml-2 mt-3">
              <h6 class="text-center primary-color">
                {{ $t("text.omit.mappedRoles") }}
              </h6>
              <div class="mt-3">
                <ul>
                  <li
                    style="list-style-type: none; padding-bottom: 10px"
                    v-for="(mappedRole, i) in mappedRoles"
                    :key="i"
                  >
                    {{ mappedRole.name }}
                    <i
                      class="mr-2 cursor-pointer fa fa-times"
                      style="
                        font-size: 10px;
                        color: white;
                        background-color: red;
                        padding: 2px;
                        border-radius: 10px;
                        border: 1px solid white;
                      "
                      :style="[
                        isButtonDisabled
                          ? { cursor: 'not-allowed' }
                          : { cursor: 'pointer' },
                      ]"
                      aria-hidden="true"
                      v-b-tooltip.hover
                      :title="$t('text.clickButtons.remove')"
                      @click="removeRole(mappedRole)"
                    ></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  </div>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import VueTagsInput from "@johmun/vue-tags-input";
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  components: {
    MasterLayout,
    VueTagsInput,
  },
  data() {
    return {
      backgroundUrl,
      company: null,
      categoryName: this.$route.query.category,
      branches: [],
      tag: "",
      tags: [],
      searchInp: "",
      isButtonDisabled: null,
      options: [],
      options2: [],
      options3: [],
      selected: [],
      combinedOptions: [],
      allRoles: null,
      mappedRoles: [],
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getRoles();
      }
    },

    tags: function (newTags, oldTags) {
      let newSelectedArray = [];

      if (newTags.length === oldTags.length) {
        newTags.forEach((tg) => {
          newSelectedArray.push(tg);
        });
        this.selected = newSelectedArray;
      } else {
        newTags.forEach((tg) => {
          newSelectedArray.push(tg.text);
        });
      }
    },
    allRoles() {
      this.getRolesMapped();
    },
  },
  mounted() {},

  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      this.companyId = this.$route.query.companyId
        ? this.$route.query.companyId
        : this.company.id;
      this.getRoles();
      this.getRolesMapped();
    });
  },

  computed: {
    filteredList() {
      const sortedList = [...this.options];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
    filteredList2() {
      const sortedList = [...this.options2];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
    filteredList3() {
      const sortedList = [...this.options3];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
    selectAll: {
      get: function () {},
      set: function (value) {
        let selected = [];
        let combinedArray = [
          ...this.options,
          ...this.options2,
          ...this.options3,
        ];
        if (!value) {
          this.selected = selected;
          this.tags = selected;
          return;
        }
        if (value) {
          combinedArray.forEach(function (opt) {
            selected.push(opt.text);
          });
          this.selected = selected;
          this.tags = selected;
        }
      },
    },
  },
  methods: {
    toggleBranchListDropdown() {
      this.showBranchListDropDown = !this.showBranchListDropDown;
    },

    removeRole(mappedRole) {
      const confirm = window.confirm(
        `${this.$t("text.omit.removeRole")} ${mappedRole.name} ?`
      );
      if (!confirm) {
        return;
      }
      const data = {
        subCategoryName: this.$route.query.category,
        roleName: mappedRole.name,
      };
      this.isButtonDisabled = true;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/GroupManagement/RemoveSubCategoryRole/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.omit.removedRoleSuccess"),
            type: "success",
            duration: 3000,
          });

          this.isButtonDisabled = false;
          this.getRoles();
          this.getRolesMapped();
        })
        .catch((error) => {
          this.isButtonDisabled = false;

          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },

    //Get ROles
    getRoles() {
      this.axios
        .get(
          // `${configObject.apiBaseUrl}​/GroupManagement/GetRoles`,
          `${configObject.apiBaseUrl}/GroupManagement/GetListOfRolesByCategory/Team`,
          configObject.authConfig()
        )
        .then((res) => {
          const filteredRoles = res.data.filter((item) => item.name !== "Team");

          this.allRoles = filteredRoles;
          filteredRoles.forEach((el) => {
            el.text = el.name;
            el.value = el.name;
          });
          let copiedResponse = [...filteredRoles];
          let options = [];
          let options2 = [];
          let options3 = [];
          copiedResponse.forEach((br, index) => {
            let dataLengthFirstOneThird = copiedResponse.length / 3;
            if (index <= dataLengthFirstOneThird) {
              options.push(br);
            }
          });

          let twoThirdOfArr = copiedResponse.splice(
            copiedResponse.length / 3 + 1,
            copiedResponse.length - 1
          );
          twoThirdOfArr.forEach((br, index) => {
            let dataHalfList = parseInt(twoThirdOfArr.length / 2);
            if (index <= dataHalfList) {
              options2.push(br);
            } else {
              options3.push(br);
            }
          });

          this.options = options;
          this.options2 = options2;
          this.options3 = options3;

          this.combinedOptions = [...options, ...options2, ...options3];
        })
        .catch((error) => {});
    },
    toggleChckBox($event) {
      if ($event.target.checked) {
        if (!this.tags.includes($event.target.value)) {
          this.tags.push($event.target.value);
          const getIndex = this.selected.indexOf($event.target.value);
          if (getIndex === -1) {
            this.selected.push($event.target.value);
          } else {
            this.selected.splice(getIndex, 1);
          }
        }
      } else {
        if (this.tags.includes($event.target.value)) {
          const getIndex = this.tags.indexOf($event.target.value);
          this.tags.splice(getIndex, 1);
        }
      }
    },
    //List of mappedMAP ROLES
    getRolesMapped() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/GroupManagement/GetRolesBySubCategory/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/${this.categoryName}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.mappedRoles = res.data;
          // To highlight mapped roles on tags and list
          const data = [];
          this.allRoles.forEach((el) => {
            data.push(el.name);
          });
          let tags = [];
          let selected = [];
          res.data.forEach((role) => {
            if (data.includes(role.name)) {
              tags.push(role.name);
              selected.push(role.name);
            }
          });
          this.tags = tags;
          this.selected = selected;
        })
        .catch((error) => {});
    },

    //Add ROles Mapped
    mapCategoryRole() {
      let roles = this.selected;
      if (!this.selected) {
        this.$toast(this.$t("text.error.selectRole"), {
          type: "error",
          timeout: 3000,
        });
        return;
      }
      this.isButtonDisabled = true;
      $(".loader").show();

      const data = {
        subCategoryName: this.categoryName,
        roleNames: this.selected,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/GroupManagement/PostSubCategoryRole/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: this.$t("text.omit.successfullyUpdatedRole"),
            type: "success",
            duration: 3000,
          });
          this.getRoles();
          this.getRolesMapped();
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
  },
};
</script>
